import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { AuthContextProvider } from './context/AuthContext'
import { DevicesContextProvider } from './context/DeviceContext'
import { SystemsContextProvider } from './context/SystemContext'
import { NotificationContextProvider } from './context/NotificationContext'
import { SnackbarProvider } from 'notistack'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthContextProvider>
      <DevicesContextProvider>
        <SystemsContextProvider>
          <NotificationContextProvider>
            <SnackbarProvider anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <App />
            </SnackbarProvider>
          </NotificationContextProvider>
        </SystemsContextProvider>
      </DevicesContextProvider>
    </AuthContextProvider>
  </React.StrictMode>
)
